function getErrorPath(path) {
  return path.join(".");
}

export { getErrorPath };